<template>
  <footer class="bg-gray-900 py-2 pb-5 text-gray-700">
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap justify-between items-start gap-8 mb-10 md:flex-row flex-col md:items-start items-center">
      </div>
      <div class="text-center pt-5 border-t border-gray-200">
        <p>© {{ new Date().getFullYear() }} Rendery Consortium. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script> 